export const ADMIN_COMPANY_ACTIONS = ["CONTRAPARTE", "CADASTRO CVM", "CADASTRO BACEN"]
